import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "https://equantumconsults.com";
const DEFAULT_IMG = SITE + "/assets/og-cover.jpg";

export default function Seo({
  title,
  description,
  path = "/",
  image = DEFAULT_IMG,
  type = "website",
  noindex = false,
}) {
  const fullTitle = title
    ? `${title} | E-Quantum Consults`
    : "E-Quantum Consults | Artist-First Music Consulting";
  const url = SITE + path;
  const desc =
    description ||
    "E-Quantum Consults helps artists own, collect, track, monetize and amplify their intellectual property. Publishing, royalty recovery, distribution and sync placements.";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="E-Quantum Consults" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
